<template>
  <div v-if="music">
    <div class="top">
      <img :src="userInfo.domain + music.avatar" alt="">
      <div class="info">
        <div class="van-ellipsis w-200 fs-18">{{ music.nickname }}</div>
        <p class="mt-4 color-B7BDCA fs-12">创建时间：{{ music.jointime * 1000 | formatTime }}</p>
      </div>
    </div>
    <div class="bottom flex align-center">
      <span class="mr-20"><i class="iconfont icon-zhuyinpin fs-12"></i> 上线作品数量：{{ music.music_online_cnt }}</span>
      <span class="flex align-center"><img :src="require('@/assets/me@2x.png')" class="w-15 mr-6" alt=""> 状态：{{ music.is_verify === 0 ? '未实名' : '已实名' }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AgentCard',
  props: {
    music: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['userInfo'])
  }
}
</script>

<style lang="scss" scoped>
.top{
  display: flex;
  align-items: center;
  .info{
    flex: 1;
    margin-left: 15px;
    color: #0D0E15;
  }
  img{
    width: 60px;
    height: 60px;
    border-radius: 50%;

  }
}
.bottom{
  margin-top: 10px;
  font-size: 12px;
}
</style>
